const routes = {
  addSupplier: "supplier-bills/addSupplier",
  editSupplier: "supplier-bills/editSupplier",
  getSupplier: "supplier-bills/suppliers",
  getSupplierDetail: "supplier-bills/supplierDetails",
  addBill: "supplier-bills/addBill",
  editBill: "supplier-bills/editBill",
  getBill: "supplier-bills/bills",
  getBillDetails: "supplier-bills/billDetails",
   getBillDetailsPreview: "supplier-bills/billDetails/preview",
  approveBill: "supplier-bills/approveBill",
  deleteBill: "supplier-bills/deleteBill",
  payBill: "supplier-bills/payBill",
  deletePaidBill: "supplier-bills/paidBill",
};

export default routes;
